import { Component, OnInit } from '@angular/core';
import { RoutingStateService } from 'src/app/core/services/routing-state/routing-state.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-401',
  templateUrl: './401.component.html',
  styleUrls: ['./401.component.scss']
})
export class UnauthorizedComponent implements OnInit {

  constructor(private routingStateService: RoutingStateService) { }

  ngOnInit() {
  }

  goBack(){
    let baseRef = environment.server;
    if (!baseRef.endsWith("/")) {
      baseRef += "/";
    }

    let returnUrl = this.routingStateService.getPreviousUrlBeforeError();

    window.location.href = baseRef + 'web/#' + returnUrl;

  }

}
